import { Card, Statistic } from 'antd';
import { useGetOverdueAggregatedStatistics } from 'api/statistic/use-get-overdue-aggregated-statistics';
import { EOverdueType } from 'shared/stores/use-overdue-filters';
import type { IOverdueStatProps } from './types';

export const OverdueStat = (props: IOverdueStatProps) => {
  const { date } = props;

  const { data } = useGetOverdueAggregatedStatistics({
    filters: { date, type: EOverdueType.unloading },
  });

  return (
    <Card>
      <Statistic title='Overdue percentage' value={data?.percent ?? 0} suffix='%' precision={1} />
    </Card>
  );
};
